module.exports = __webpack_public_path__ + "static/img/off.d81bda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/cursor/off.png
// module id = Ug5b
// module chunks = 0